import { render, staticRenderFns } from "./KkArrow.vue?vue&type=template&id=3e54d7dd&scoped=true"
import script from "./KkArrow.vue?vue&type=script&lang=js"
export * from "./KkArrow.vue?vue&type=script&lang=js"
import style0 from "./KkArrow.vue?vue&type=style&index=0&id=3e54d7dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e54d7dd",
  null
  
)

export default component.exports